export const tableHeader = [
  'Institue Name',
  'Institue Code',
  'Mobile Number',
  'Email',
  'City',
  'Zipcode',
  'Expires On',
  'Status',
  'Action'
]
